// extracted by mini-css-extract-plugin
export default {"test-form":"_25fdlXAFCD","testForm":"_25fdlXAFCD"};
    if(module.hot) {
      // 1623933194050
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  